import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar, { getPageName } from './Navbar';
import './Layout.css';

const Layout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.title = `${getPageName(location.pathname)} · Farmers Hub`;
  }, [location.pathname]);

  return (
    <div className="layout-root">
      <Navbar collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
      <main className="main-content">{children}</main>
    </div>
  );
};

export default Layout;
